// Browser side of FcCore::SignupBotChecker: the server only trusts a registration that
// carries a token fetched by this script a couple of seconds earlier.

const TOKEN_URL = "/sign_up/bot_check_token"
const FETCH_TIMEOUT_MS = 5000
// The server wants 2 s between issuing a token and using it.
const MIN_FILL_MS = 2300
// Server-side tokens live for an hour.
const MAX_AGE_MS = 50 * 60 * 1000

let pending = null

async function fetchToken() {
  let timeout
  try {
    const request = fetch(TOKEN_URL, {
      credentials: "include",
      headers: { Accept: "application/json" },
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((body) => (body && body.token ? { token: body.token, fetchedAt: Date.now() } : null))

    return await Promise.race([
      request,
      new Promise((resolve) => {
        timeout = window.setTimeout(() => resolve(null), FETCH_TIMEOUT_MS)
      }),
    ])
  } catch (error) {
    return null
  } finally {
    window.clearTimeout(timeout)
  }
}

// Call when a sign-up form opens, so that the token is old enough once the form is submitted.
export function prepareBotCheckToken() {
  if (!pending) {
    const request = fetchToken().then((entry) => {
      if (!entry && pending === request) pending = null
      return entry
    })
    pending = request
  }
  return pending
}

// Tokens are single-use, so each one is forgotten as soon as it is handed out.
async function takeBotCheckToken() {
  let entry = await prepareBotCheckToken()
  if (entry && Date.now() - entry.fetchedAt > MAX_AGE_MS) {
    pending = null
    entry = await prepareBotCheckToken()
  }
  pending = null
  if (!entry) return null

  const wait = MIN_FILL_MS - (Date.now() - entry.fetchedAt)
  if (wait > 0) await new Promise((resolve) => window.setTimeout(resolve, wait))
  return entry.token
}

// `send(token)` posts the registration and resolves to { response, body }.
// It is called a second time, with a fresh token, when the server answers "retryable".
export async function withBotCheckToken(send) {
  const result = await send(await takeBotCheckToken())
  if (!(result.body && result.body.retryable)) return result

  return send(await takeBotCheckToken())
}
